import SideNavLayout from "../../customsidenav/sidenavlayout"

const Refills=()=>{
    return(<>
    
    <SideNavLayout>

        refills
    </SideNavLayout>
    </>)
}
export default Refills